import { type ComponentProps } from 'react';

export const ArrowNextIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M16.5039 12H3.00391" stroke="currentColor" strokeLinecap="round" />
      <path d="M12 3L21 12L12 21" stroke="currentColor" strokeLinecap="round" />
    </svg>
  );
};
